import { Tabs } from "antd";
import i18next from "i18next";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import "./style";

const CustomTab = ({
  onTabChange = () => {},
  tabItems = [],
  activeKey,
  tabBarStyle = {},
  className = "",
  tabBarGutter = 0,
}) => {
  const { t } = useTranslation();
  const { TabPane } = Tabs;
  return (
    <div className={className ? className : "tab-container"}>
      <Tabs
        tabBarStyle={className ? {} : { display: "flex", flexGrow: "1", ...tabBarStyle }}
        tabBarGutter={tabBarGutter}
        centered
        onChange={onTabChange}
        activeKey={activeKey}
      >
        {tabItems?.map((tabItem, index) => {
          let winTitle = tabItem.name;
          if (tabItem.translate === true) {
            tabItem.name.every((_name) => {
              if (i18next.exists(_name)) {
                winTitle = _name;
                return false;
              }
              return true;
            });
          }
          return (
            <TabPane
              key={`${tabItem.key}`}
              tab={tabItem.translate ? <Trans i18nKey={winTitle} /> : tabItem.name}
            >
              {tabItem.component}
            </TabPane>
          );
        })}
      </Tabs>
    </div>
  );
};

export default CustomTab;
